import { formatPrice } from "./priceFormatters";

export const priceAccessor = (price) => {
	return `${price.name ? `${price.name} (` : ""}${formatPrice(price)}${price.name ? ")" : ""}`;
};
